
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "allTurnover",
})
export default class allTurnover extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
		  time:'',
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    
	this.getAccountList(1);
  }
  
  private getAccountList(num:number){
	  
	  let datas = [];
	  this.pageNo = num;
	  let pageNum = this.pageNo;
	  let pageSize = 10;
	  let paramter = {
	  	'pageSize':this.pageSize,
	  	'pageNum':this.pageNum,
	  };
	  this.$http.get("shop/list", {params:paramter}).then((res: any) => {
	  	datas = res.data.data.data;
	  	this.tableData = datas;
	  	this.tableData = this.tableData.map(item=>{
	  		
	  		let logoDatas = [];
	  		logoDatas.push(item.trademark);
	  		item.images = logoDatas;
	  		item.enable = item.enable == 1?true:false;
	  		return item;
	  	});
	  	console.log('普通用户',this.tableData);
	  });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
	this.getAccountList(this.pageNo);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleFirmInfo(index,row){
  	  
  	  console.log(row);
	  this.$router.push('/Firm/editFirm/?id='+row.id)
  }
  private handleTurnoverDetail(index,row){
  	  
  	  console.log(row);
  	  this.$router.push('/Firm/orderDetail/?id='+row.id)
  }
}
